import { h, Component, Host, Prop } from '@stencil/core';

import { getCSSVariable } from '../../../services/utils';

@Component({
  tag: 'pk-countdown',
  styleUrl: './scss/pk-countdown.scss',
  shadow: true,
})
export class PkCountdown {
  // Own Properties
  // ====================

  private cssComponentPrefix = `--countdown`;

  // Reference to host HTML element
  // ===================================

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** It will set or change the background color of the countdown element container */
  @Prop({ reflect: true }) background: string;

  /** It will set or change the background color of the time value element container inside the countdown item */
  @Prop({ reflect: true }) backgroundTimer: string;

  /** It will set or change the text color for all the elements of the countdown */
  @Prop({ reflect: true }) color: string;

  /** It will set the amount of space (in pixels) between the items of the countdown timer */
  @Prop({ reflect: true }) itemSpacing: number;

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    const styles = {
      ...(this.color && {
        [`${this.cssComponentPrefix}--color`]: getCSSVariable(`${this.color}`),
      }),
      ...(this.background && {
        [`${this.cssComponentPrefix}--background-color`]: getCSSVariable(`${this.background}`),
      }),
      ...(this.backgroundTimer && {
        [`${this.cssComponentPrefix}-item--background-color`]: getCSSVariable(`${this.backgroundTimer}`),
      }),
      ...(this.itemSpacing && {
        [`${this.cssComponentPrefix}-item--margin-right`]: `${this.itemSpacing}px`,
      }),
    };

    return (
      <Host style={{ ...styles }}>
        <div class="countdown--container bg-[color:--countdown--background-color] p-[--countdown--padding]" part="base">
          <div class="countdown--container__heading" part="heading">
            <slot name="heading" />
          </div>
          <div class="countdown--container__timer" part="timer">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
